import { InjectionToken } from '@angular/core';

export interface INgAuthConfig {
  // authNextURL?: string, // popup or redirect
  // tosUrl?: string, // term of services url
  // ppUrl?: string, // privacy policy url
  // authProviders?: Array<AuthProvider>,
  // languageCode?: string, // todo: 28.3.18
  authGuardFallbackURL?: string;
  authGuardLoggedInURL?: string;
  enableFirestoreSync?: boolean;

  // Toasts
  toastMessageOnAuthSuccess?: boolean;
  toastMessageOnAuthError?: boolean;

  // Password length min/max in forms independently of each componenet min/max.
  // `min/max` input parameters in components should be within this range.
  passwordMaxLength?: number;
  passwordMinLength?: number;

  // Same as password but for the name
  nameMaxLength?: number;
  nameMinLength?: number;

  // If set, sign-in/up form is not available until email has been verified.
  // Plus protected routes are still protected even though user is connected.
  guardProtectedRoutesUntilEmailIsVerified?: boolean;

  // Control whether or not email verification is used
  enableEmailVerification?: boolean;

  // If set to true outputs the UserCredential object instead of firebase.User after login and signup
  useRawUserCredential?: boolean;
}

export const DEFAULT_AUTH_FIREBASE_UI_CONFIG: INgAuthConfig = {
  // authMethod: 'redirect',
  // authProviders: [new GoogleAuthProvider(), new FacebookAuthProvider(), new TwitterAuthProvider(), new GithubAuthProvider()],
  enableFirestoreSync: true,
  toastMessageOnAuthSuccess: true,
  toastMessageOnAuthError: true,
  authGuardFallbackURL: '/',
  authGuardLoggedInURL: '/',

  // Password length min/max in forms independently of each componenet min/max.
  // `min/max` input parameters in components should be within this range.
  passwordMaxLength: 60,
  passwordMinLength: 8,

  // Same as password but for the name
  nameMaxLength: 50,
  nameMinLength: 2,

  // If set, sign-in/up form is not available until email has been verified.
  // Plus protected routes are still protected even though user is connected.
  guardProtectedRoutesUntilEmailIsVerified: true,

  // Default to email verification on
  enableEmailVerification: true,

  // Default to false to keep the current projects working as is
  useRawUserCredential: false,
};

// Merge default config with user provided config.
// eslint-disable-next-line @typescript-eslint/naming-convention
export function ngAuthConfigFactory(
  userProvidedConfig: INgAuthConfig
): INgAuthConfig {
  return { ...DEFAULT_AUTH_FIREBASE_UI_CONFIG, ...userProvidedConfig };
}

export const NG_AUTH_CONFIG_TOKEN = new InjectionToken<INgAuthConfig>(
  'NG_AUTH_CONFIG_TOKEN'
);
// This is an intermediate token containing only user-provided configuration
export const USER_PROVIDED_CONFIG_TOKEN = new InjectionToken<INgAuthConfig>(
  'USER_PROVIDED_CONFIG_TOKEN'
);
